// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.C_RVIAfZmp2rWY {
  margin-bottom: 0;
  padding: 0;
  background: transparent;
}
.C_RVIAfZmp2rWY:hover,
.C_RVIAfZmp2rWY:focus,
.C_RVIAfZmp2rWY:active {
  background: transparent;
}
.C_RVIAfZmp2rWY:hover svg,
.C_RVIAfZmp2rWY:focus svg,
.C_RVIAfZmp2rWY:active svg {
  transform: scale(1.2);
  transition-property: transform;
  transition-duration: 85ms;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `C_RVIAfZmp2rWY`
};
export default ___CSS_LOADER_EXPORT___;
